module.exports = __webpack_public_path__ + "img/Google_logo.e99543bb.svg";